module.exports = __webpack_public_path__ + "assets/img/sdwan-module6-3.2419d6ad.jpg";